import { pdkAxios } from '@/lib/pdk-axios';
import type { Deal } from '@/models/registry';
import { dealStore } from '@/models/stores/deals';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ArchiveRestore } from 'lucide-react';

export const useRestorePaymentMutation = ({
  dealId,
  paymentId,
}: {
  dealId: Deal['id'];
  paymentId: Deal['payments'][0]['id'] | null;
}) => {
  const queryClient = useQueryClient();
  const restorePaymentMutation = useMutation({
    onMutate: async () => {
      if (!paymentId) {
        console.error('No payment id provided');
        return;
      }

      dealStore.restorePayment(paymentId);
    },
    mutationFn: async (): Promise<Deal['payments']> => {
      const route = `deals/${dealId}/payments/${paymentId}/restore`;
      // /deals/:id/payments/:payment_id/delete

      const response = await pdkAxios
        .post(`/${route}`, {
          // sales_reps: salesRepsIds,
        })
        .catch((e) => {
          console.error('Error restoring payment', e);
          throw e;
        });

      return response.data;
    },
    onSuccess: () => {},
    onError: (error, variables) => {
      console.error('Error restoring payment', error, variables);
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['deal', dealId] });
    },
  });

  return { restorePaymentMutation };
};

const PaymentRestoreMenuItem = ({
  // dealId,
  payment,
  onSelect,
}: {
  // dealId: Deal["id"];
  payment: Deal['payments'][0];
  onSelect: (paymentId: Deal['payments'][0]['id']) => void;
}) => {
  return (
    <div
      className="flex flex-row gap-2 w-full items-center"
      onClick={() => {
        onSelect(payment.id);
      }}
    >
      <ArchiveRestore className="size-3.5" />
      <div className="flex flex-col text-nowrap truncate">
        <p className="text-xs">Restore payment</p>
        {/* <p className="text-xs text-muted-foreground">{tradeIn.vin}</p> */}
      </div>
    </div>
  );
};

export default PaymentRestoreMenuItem;
